import React from 'react'
import styled from 'styled-components'
import { Container, MOBILE } from '../CustomLanding.styled'
import { colors, stats } from '../content'

const TrustStats: React.FC = () => (
	<Section>
		<Container>
			<Title>{stats.title}</Title>
			<Grid>
				{stats.items.map(item => (
					<Cell key={item.value}>
						<Value accent={item.accent}>{item.value}</Value>
						<Text>{item.text}</Text>
					</Cell>
				))}
			</Grid>
		</Container>
	</Section>
)

export default TrustStats

const Section = styled.section`
	background: ${colors.paper};
	padding: 56px 0 8px;
	${MOBILE} {
		padding: 40px 0;
	}
`

const Title = styled.h2`
	font-weight: 700;
	font-size: clamp(24px, 2.2vw, 34px);
	line-height: 1.35;
	color: ${colors.navy};
	margin: 0 0 30px;
	max-width: 680px;
	${MOBILE} {
		font-size: 26px;
		line-height: 1.4;
		margin-bottom: 26px;
	}
`

const Grid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
	gap: 0;
	border-top: 1px solid ${colors.line};
`

const Cell = styled.div`
	padding: 24px 28px;
	border-bottom: 1px solid ${colors.line};
	&:first-child {
		padding-inline-start: 0;
	}
	&:not(:first-child) {
		border-inline-start: 1px solid ${colors.line};
	}
	${MOBILE} {
		padding: 22px 0;
		&:not(:first-child) {
			border-inline-start: none;
		}
		&:last-child {
			border-bottom: none;
		}
	}
`

const Value = styled.div<{ accent: boolean }>`
	font-weight: 800;
	font-size: ${p => (p.accent ? '34px' : '23px')};
	line-height: ${p => (p.accent ? '1.1' : '1.35')};
	color: ${p => (p.accent ? colors.maroon : colors.navy)};
	margin-bottom: 10px;
	${MOBILE} {
		font-size: ${p => (p.accent ? '32px' : '22px')};
		margin-bottom: 7px;
	}
`

const Text = styled.p`
	margin: 0;
	font-size: 16px;
	line-height: 1.85;
	color: ${colors.muted};
	${MOBILE} {
		font-size: 15px;
		line-height: 1.8;
	}
`
